var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.902 1C11.9693 1.03554 12.4143 1.89945 12.4772 2.01465C13.0204 3.01085 13.5711 4.00332 14.1295 4.99121C14.35 5.38068 14.6169 5.87303 14.858 6.24414C15.4121 7.09647 15.9494 7.84131 16.3444 8.79199C16.7129 9.6853 16.9256 10.6345 16.9742 11.5986C17.1613 14.8505 15.1182 16.8096 11.9244 16.9834C8.91235 16.972 6.61829 14.467 6.8678 11.5029C7.09194 8.84063 8.29177 7.50373 9.55042 5.30078C10.3583 3.88045 11.1426 2.44637 11.902 1ZM14.2711 7.04297C14.812 8.1134 15.0592 8.36171 15.2018 9.5C15.3569 10.7226 15.1201 11.6822 15.2018 12.3311C15.2835 12.9799 16.1197 13.0611 16.3649 12.3311C16.6099 11.6008 16.0375 8.7621 14.3698 7.11621C14.3534 7.09521 14.2919 7.05567 14.2711 7.04297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9833 12.9269C18.0781 13.3818 18.9244 15.1404 19.1622 15.6979C20.1959 18.1228 21.3882 20.5618 22.4003 22.9891C21.2395 23.0041 20.0505 22.9917 18.8876 22.9921C17.5595 23.0045 17.3678 22.0233 16.9938 20.9912C16.7599 20.3457 16.5328 19.6928 16.2936 19.0492C15.4559 19.085 14.3067 19.0391 13.4479 19.0343L7.48275 18.9839C7.34975 19.605 6.88808 20.4258 6.66732 21.037C5.92531 23.0917 6.01941 23.0011 3.92251 22.999L1.40027 22.9951L4.28093 16.5461C4.74705 15.5039 5.37204 13.9833 5.87718 13.008C6.03228 13.6839 6.29252 14.2861 6.59876 14.9024C8.53814 18.8049 14.5274 19.1118 16.8951 15.4745C17.4643 14.6 17.6868 13.9112 17.9833 12.9269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/academy_icon.2d0383e4661f1f80983f636eaa96a859.svg";
export { ForwardRef as ReactComponent };